import { Routes } from '@angular/router';

export const routes: Routes = [
  // Define your application routes here

  //Default route
  {
    path: '',
    loadComponent: () =>
      import('./Pages/scan-qr/scan-qr.component').then(
        (m) => m.ScanQRComponent
      ),
  },
];
